import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  data() {
    return {
      loading: false,
      emails_fact: [],
      razones_sociales: [],

      alta_facturacion: {
        razon_social: "",
        email: "",
      },

      emailAsociado: "",

    };
  },

  computed: {},
  mounted: function () {
    window.comp1 = this;
    $(".box").boxWidget();

    this.emails_facturacion();
    this.cliente_razones_sociales_facturar();
    this.getUserMail();

  },

  methods: {

    emails_facturacion() {

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "geteMf",
          },
          {
            withCredentials: true
          }
        )
        .then(response => {

          if (response.data.status == 1) {

            this.emails_fact = response.data.data;

          } else {
            this.emails_fact = [];
          }

          this.loading = false;
        });

    },


    eliminar_email(email) {


      if (confirm("Desea eliminar el email " + email.mail + " de la entidad " + email.razon_social + "?")) {
        this.$http
          .post(
            "SERVER/scd/configs/",
            {
              a: "delemc",
              id: email.id
            },
            {
              withCredentials: true
            }
          )
          .then(response => {
            this.emails_facturacion();

            this.loading = false;
          });
      }



    },


    add_email_facturacion() {

      if (this.alta_facturacion.razon_social != "" && this.alta_facturacion.email != "") {

        this.$http
          .post(
            "SERVER/scd/configs/",
            {
              a: "addeamf",
              razon_social: this.alta_facturacion.razon_social,
              email: this.alta_facturacion.email
            },
            {
              withCredentials: true
            }
          )
          .then(response => {

            if (response.data.status == 333) {
              this.showNotification({
                msj: "Error al cargar el Correo, compruebe la información.",
                bg: "bg-red"
              });

            } else if (response.data.status == 1) {

              this.alta_facturacion = {
                razon_social: "",
                email: "",
              }

            }

            this.emails_facturacion();


            this.loading = false;
          });

      }
    },

    cliente_razones_sociales_facturar() {

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "razSc",
          },
          {
            withCredentials: true
          }
        )
        .then(response => {

          if (response.data.status == 1) {

            this.razones_sociales = response.data.data;

          } else {
            this.razones_sociales = [];
          }


          this.loading = false;
        });

    },
    configEmailAsociado() {
      this.loading = true;
      this.$http
        .post(
          "/config/perfil/email/",
          {
            email: this.emailAsociado,
          }

        )
        .then(response => {
          this.getUserMail();
        }).catch(err => { 
          alert(err.response.data)
          this.emailAsociado='';
          this.loading = false;
        });;

    },


    getUserMail() {
      this.$http
        .get("/config/perfil/email/")
        .then(response => {
          this.emailAsociado = response.data.mail;
      
          this.loading = false;
        }) 

    },
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/profile/main/index.js